// T048 — Outcome selected event definition.

import type { EventDefinition } from './navigation';

export type OutcomeSelectedProperties = {
  marketPubkey: string;
  outcomeIndex: number;
  source: 'legend' | 'pill' | 'chart';
};

export const OUTCOME_SELECTED: EventDefinition<OutcomeSelectedProperties> = {
  name: 'outcome_selected',
};
